import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { captureException } from '@src/quince-site-common/src/utils/sentryUtil'

const richTextRenderer = (_content, ...rest) => {
  try {
    const content = typeof _content === 'string' ? JSON.parse(_content) : _content
    return documentToReactComponents(content, ...rest)
  } catch (error) {
    captureException('Error while rendering richtext', { error })
  }
}

export default richTextRenderer
